module.exports = __webpack_public_path__ + "img/three1Orange.146203cc.jpg";